__turbopack_context__.v({
  "embedHtml": "PlasmicGdpr-module__fZlSDG__embedHtml",
  "freeBox": "PlasmicGdpr-module__fZlSDG__freeBox",
  "primaryButton": "PlasmicGdpr-module__fZlSDG__primaryButton",
  "root": "PlasmicGdpr-module__fZlSDG__root",
  "rootglobal_themePurpleDark_override": "PlasmicGdpr-module__fZlSDG__rootglobal_themePurpleDark_override",
  "svg__aVcIw": "PlasmicGdpr-module__fZlSDG__svg__aVcIw",
  "svg__l5Zf": "PlasmicGdpr-module__fZlSDG__svg__l5Zf",
  "text": "PlasmicGdpr-module__fZlSDG__text",
  "textglobal_themeOrange_override": "PlasmicGdpr-module__fZlSDG__textglobal_themeOrange_override",
});
